import {
  FETCH_TEMPLATES_REQUEST,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  FETCH_TEMPLATE_DETAIL_REQUEST,
  FETCH_TEMPLATE_DETAIL_SUCCESS,
  FETCH_TEMPLATE_DETAIL_FAILURE,
  SEND_TEST_EMAIL_REQUEST,
  SEND_TEST_EMAIL_SUCCESS,
  SEND_TEST_EMAIL_FAILURE
} from '../../constants/ActionTypes';

const initialState = {
  templates: [],
  templateDetail: {},
  loading: false,
  detailLoading: false,
  sendEmailLoading: false,
  sendEmailSuccess: false,
  error: null,
  detailError: null,
  sendEmailError: null
};

const templateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Templates List
    case FETCH_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        templates: action.payload,
        error: null
      };
    
    case FETCH_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'Failed to fetch templates'
      };

    // Fetch Template Details
    case FETCH_TEMPLATE_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
        detailError: null
      };
    
    case FETCH_TEMPLATE_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        templateDetail: action.payload,
        detailError: null
      };
    
    case FETCH_TEMPLATE_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        detailError: action.payload || 'Failed to fetch template details'
      };

    // Send Test Email
    case SEND_TEST_EMAIL_REQUEST:
      return {
        ...state,
        sendEmailLoading: true,
        sendEmailSuccess: false,
        sendEmailError: null
      };
    
    case SEND_TEST_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailLoading: false,
        sendEmailSuccess: true,
        sendEmailError: null
      };
    
    case SEND_TEST_EMAIL_FAILURE:
      return {
        ...state,
        sendEmailLoading: false,
        sendEmailSuccess: false,
        sendEmailError: action.payload || 'Failed to send test email'
      };

    default:
      return state;
  }
};

export default templateReducer;
